/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnExerciseStatus } from './en-exercise-status';
import { ExerciseLanguageDto } from './exercise-language-dto';
import { ExerciseSourceDto } from './exercise-source-dto';
import { ExerciseToolDto } from './exercise-tool-dto';
import { ExerciseWeightDto } from './exercise-weight-dto';
import { TagDto } from './tag-dto';
 /**
 *
 *
 * @export
 * @interface ExerciseDto
 */
export interface ExerciseDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ExerciseDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ExerciseDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof ExerciseDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof ExerciseDto
     */
    orientation: ExerciseDtoOrientationEnum;

    /**
     * @type {string}
     * @memberof ExerciseDto
     */
    side: ExerciseDtoSideEnum;

    /**
     * @type {string}
     * @memberof ExerciseDto
     */
    position: ExerciseDtoPositionEnum;

    /**
     * @type {string}
     * @memberof ExerciseDto
     */
    direction: ExerciseDtoDirectionEnum;

    /**
     * @type {number}
     * @memberof ExerciseDto
     */
    rotation: number;

    /**
     * @type {number}
     * @memberof ExerciseDto
     */
    duration: number;

    /**
     * @type {boolean}
     * @memberof ExerciseDto
     */
    isStatic: boolean;

    /**
     * @type {EnExerciseStatus}
     * @memberof ExerciseDto
     */
    status: EnExerciseStatus;

    /**
     * @type {string}
     * @memberof ExerciseDto
     */
    note: string;

    /**
     * @type {Array<ExerciseSourceDto>}
     * @memberof ExerciseDto
     */
    sources: Array<ExerciseSourceDto>;

    /**
     * @type {Array<ExerciseWeightDto>}
     * @memberof ExerciseDto
     */
    weights: Array<ExerciseWeightDto>;

    /**
     * @type {Array<ExerciseToolDto>}
     * @memberof ExerciseDto
     */
    tools: Array<ExerciseToolDto>;

    /**
     * @type {Array<ExerciseLanguageDto>}
     * @memberof ExerciseDto
     */
    languages: Array<ExerciseLanguageDto>;

    /**
     * @type {Array<TagDto>}
     * @memberof ExerciseDto
     */
    tags: Array<TagDto>;
}

/**
 * @export
 * @enum {string}
 */
export enum ExerciseDtoOrientationEnum {
    VERTICAL = 'VERTICAL',
    HORIZONTAL = 'HORIZONTAL'
}
/**
 * @export
 * @enum {string}
 */
export enum ExerciseDtoSideEnum {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}
/**
 * @export
 * @enum {string}
 */
export enum ExerciseDtoPositionEnum {
    STANDING = 'STANDING',
    SEATED = 'SEATED',
    PRONE = 'PRONE',
    SUPINE = 'SUPINE',
    KNEELING = 'KNEELING'
}
/**
 * @export
 * @enum {string}
 */
export enum ExerciseDtoDirectionEnum {
    FRONTAL = 'FRONTAL',
    LATERAL = 'LATERAL',
    BEHIND = 'BEHIND'
}

